import { Controller } from "@hotwired/stimulus"

// AnnullaMovimento di pages/Piani.js: «Annulla» apre il form al suo posto, «Lascia» lo richiude (motivo e nota
// restano scritti, come lo stato del componente); «Annulla il movimento» si accende solo col motivo scelto.
export default class extends Controller {
  static targets = ["apri", "form", "motivo", "conferma"]

  apri() {
    this.mostra(true)
  }

  lascia() {
    this.mostra(false)
  }

  aggiorna() {
    this.confermaTarget.disabled = !this.motivoTarget.value
  }

  mostra(aperto) {
    this.apriTarget.hidden = aperto
    this.formTarget.hidden = !aperto
    this.aggiorna()
  }
}
